(($, Drupal) => {
  const id = "html-main";

  Drupal.behaviors[id] = { attach: (context, settings) => {
    once(id, ".paragraph table, .node table", context).forEach((item) => {
      $(item).wrap("<div class='table-responsive'></div>");
    });
  }};
})(jQuery, Drupal);
